module.exports = __webpack_public_path__ + "assets/image-placeholder.6f32f1b8.svg";